import React from "react";
import { MessageCircle, Phone, Pizza } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const contactNumbers = [{
  phone: "743-336-7302",
  label: "Main Office"
}, {
  phone: "743-336-7302",
  label: "Direct Text"
}];
export default function OrderContact() {
  return <section data-section-id="262725" id="final-cta-banner-section" className="bg-secondary text-foreground py-20 px-6 md:py-32">
      <div className="max-w-4xl mx-auto text-center flex flex-col items-center">
        <div className="bg-primary/10 p-4 rounded-lg mb-8 shadow-md">
          <Pizza className="size-12 md:size-16 text-primary" />
        </div>
        
        <h2 className="font-default text-4xl md:text-6xl font-bold mb-6 text-[#F2E8CF] tracking-tight">
          Ready to transform your property?
        </h2>
        
        <p className="text-lg md:text-xl text-[#F2E8CF]/90 mb-12 max-w-2xl font-medium">
          Call, text, or fill out the form above to get started. Our team is ready to help you clear the way for your next project.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-16">
          <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-white h-16 px-8 text-lg md:text-xl font-bold rounded-lg shadow-lg border-none transition-transform hover:scale-105">
            <Link to="tel:5550123456">
              <Phone className="mr-2 size-6 md:size-7" />
              Call Now
            </Link>
          </Button>
          
          <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-white h-16 px-8 text-lg md:text-xl font-bold rounded-lg shadow-lg border-none transition-transform hover:scale-105">
            <Link to="#contact-form">
              <MessageCircle className="mr-2 size-6 md:size-7" />
              Submit Form
            </Link>
          </Button>
        </div>

        <div className="flex flex-col items-center gap-6 w-full max-w-2xl border-t border-white/10 pt-12">
          <p className="text-[#F2E8CF]/60 uppercase tracking-widest text-sm font-bold">
            Direct Contact Numbers
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-6 md:gap-16">
            {contactNumbers.map((contact, i) => <div key={i} data-index={i} className="flex flex-col items-center gap-1">
                <Link to={`tel:${contact.phone.replace(/-/g, '')}`} className="text-3xl md:text-4xl font-bold text-primary hover:text-primary/80 transition-colors font-default">
                  {contact.phone}
                </Link>
                <span className="text-[#F2E8CF]/50 text-sm font-medium">{contact.label}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}